/**
 * Render schedule tab with schedule and unscheduled tables.
 * Creates schedule grid and unscheduled matchUps table with date navigation.
 */
import { createUnscheduledTable } from 'components/tables/unscheduledTable/createUnscheduledTable';
import { createScheduleTable } from 'components/tables/scheduleTable/createScheduleTable';
import { unscheduledGridControl } from './unscheduledGridControl';
import { competitionEngine } from 'tods-competition-factory';
import { scheduleGridControl } from './scheduleGridControl';
import { resolveScheduleDate } from '../scheduleUtils';
import { scheduleConfig } from 'config/scheduleConfig';
import { context } from 'services/context';

// constants
import { NONE, SCHEDULE_CONTROL, UNSCHEDULED_CONTROL, UNSCHEDULED_VISIBILITY } from 'constants/tmxConstants';

export function renderScheduleTab(params: { scheduledDate?: string }): void {
  let gridControlElements: any;

  if (!params.scheduledDate) {
    const scheduledDate = resolveScheduleDate();
    const tournamentId = competitionEngine.getTournamentInfo().tournamentInfo?.tournamentId;
    context.router?.navigate(`/tournament/${tournamentId}/schedule/${scheduledDate}`);
  }
  const scheduledDate = params.scheduledDate || resolveScheduleDate();
  context.displayed.selectedScheduleDate = scheduledDate;

  const unscheduledVisibility = document.getElementById(UNSCHEDULED_VISIBILITY)!;
  const unscheduldControlAnchor = document.getElementById(UNSCHEDULED_CONTROL)!;
  const controlAnchor = document.getElementById(SCHEDULE_CONTROL)!;
  unscheduldControlAnchor.style.paddingBottom = '1em';
  controlAnchor.style.paddingBottom = '1em';

  let schedulingActive = (context.state as any).schedulingActive;
  unscheduledVisibility.style.display = schedulingActive ? '' : NONE;

  const {
    replaceTableData: updateUnscheduledTable,
    table: unscheduledTable,
    unscheduledMatchUps,
  } = createUnscheduledTable({ scheduledDate });

  const toggleUnscheduled = () => {
    schedulingActive = !schedulingActive;
    (context.state as any).schedulingActive = schedulingActive;
    unscheduledVisibility.style.display = schedulingActive ? '' : NONE;

    if (gridControlElements?.scheduleMatchUps)
      gridControlElements.scheduleMatchUps.style.display = schedulingActive ? NONE : '';
  };

  const reasonableRowCount = Math.min(50, unscheduledMatchUps?.length || 0);
  const {
    replaceTableData: updateScheduleTable,
    table: scheduleTable,
    courtsCount,
  } = createScheduleTable({
    minCourtGridRows: Math.max(scheduleConfig.get().minCourtGridRows, reasonableRowCount),
    scheduledDate,
  });

  context.refreshActiveTable = () => {
    updateUnscheduledTable();
    updateScheduleTable({ scheduledDate });
  };

  (unscheduledGridControl as any)({
    minCourtGridRows: scheduleConfig.get().minCourtGridRows,
    controlAnchor: unscheduldControlAnchor,
    matchUps: unscheduledMatchUps,
    table: unscheduledTable,
    updateUnscheduledTable,
    updateScheduleTable,
    toggleUnscheduled,
    scheduledDate,
  });

  gridControlElements = (scheduleGridControl as any)({
    table: scheduleTable,
    unscheduledMatchUps,
    updateScheduleTable,
    toggleUnscheduled,
    schedulingActive,
    controlAnchor,
    scheduledDate,
    courtsCount,
  }).elements;
}
